<template>
    <div>
        <h3 class="title is-3">Report</h3>
        <hr />
        <MonthlyLateReport />
        <br />
        <PhilHealthContriReportByMonth/>
        <br />
        <SssContriReportByMonth/>
    </div>
</template>

<script>
import MonthlyLateReport from '../../components/Report/MonthlyLateReport.vue' 
import PhilHealthContriReportByMonth from '../../components/Report/PhilHealthContriReportByMonth.vue'
import SssContriReportByMonth from '../../components/Report/SssContriReportByMonth.vue'

export default {
    components:{
        MonthlyLateReport,
        PhilHealthContriReportByMonth,
        SssContriReportByMonth
    }
}
</script>
